import { createBrowserRouter } from 'react-router-dom';
import { FaceCapturePage } from '@features/face-capture';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <FaceCapturePage />,
  },
]);
